import React, { useState } from "react";
import { memo, useMemo } from "react";
import { Icon } from "semantic-ui-react";
import { formatBarcode, FormatBarcodeOptions } from "../../../utils/formatting/barcode";

import styles from "./index.module.css";

type Props = {
  value: string;
  formatted?: boolean;
  showIcon?: boolean;
  options?: FormatBarcodeOptions;
  prefix?: string;
};

const Barcode = ({ value, formatted = true, showIcon = false, options = {}, prefix = ""  }: Props) => {
  const [copied, setCopied] = useState(false);
  const barcode = useMemo(() => (formatted ? formatBarcode(value, options).formatted : value), [
    value,
  ]);
  const onCopyBarcodeToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(barcode.trim().replaceAll(" ", ""));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy barcode", err);
    }
  };
  return (
    <div className={styles["barcode"]} onClick={onCopyBarcodeToClipboard}>
      {showIcon && <Icon name="barcode"></Icon>}
      <p>{prefix}{barcode}</p>

      {copied && <div className={styles["popup"]}>Copied: {barcode}</div>}
    </div>
  );
};

export default memo(Barcode);
